var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return !["PosRetrieveUpdate", "BranchRetrieveUpdate"].includes(
    _vm.$route.name
  )
    ? _c(
        "v-col",
        { staticClass: "px-0 pt-0 skeleton-card" },
        [
          _c(
            "v-row",
            _vm._l(6, function (action) {
              return _c(
                "v-col",
                { key: action },
                [
                  _c("v-skeleton-loader", {
                    staticClass: "rounded-md",
                    attrs: { "max-width": "260", height: "120", type: "image" },
                  }),
                ],
                1
              )
            }),
            1
          ),
          _c(
            "v-row",
            _vm._l(6, function (action) {
              return _c(
                "v-col",
                { key: action },
                [
                  _c("v-skeleton-loader", {
                    staticClass: "rounded-md",
                    attrs: { "max-width": "260", height: "120", type: "image" },
                  }),
                ],
                1
              )
            }),
            1
          ),
          _c(
            "v-row",
            [
              _c(
                "v-col",
                { attrs: { cols: "2" } },
                [
                  _c("v-skeleton-loader", {
                    staticClass: "rounded-md",
                    attrs: { type: "text" },
                  }),
                ],
                1
              ),
              _c("v-spacer"),
              _c(
                "v-col",
                { staticClass: "mr-0", attrs: { cols: "1" } },
                [
                  _c("v-skeleton-loader", {
                    staticClass: "rounded-md",
                    attrs: { type: "text" },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      )
    : _c("v-col", { staticClass: "pt-0 px-1", attrs: { cols: "12" } }, [
        _c("div", { staticClass: "d-flex" }, [
          _c(
            "div",
            { staticClass: "align-stretch" },
            [
              _c("v-skeleton-loader", {
                staticClass: "bgPanel rounded-t-md rounded-b-md",
                attrs: {
                  type: "image, article",
                  width: "380",
                  height: "calc(100vh - 20vh)",
                },
              }),
            ],
            1
          ),
          _c("div", { staticClass: "flex-grow-1 ml-2" }, [
            _c(
              "div",
              { staticClass: "d-flex" },
              _vm._l(3, function (item) {
                return _c(
                  "div",
                  { key: item, staticClass: "px-1 flex-grow-1" },
                  [
                    _c("v-skeleton-loader", {
                      staticClass: "rounded-md",
                      attrs: { transition: "fade-transition", type: "image" },
                    }),
                  ],
                  1
                )
              }),
              0
            ),
            _c(
              "div",
              { staticClass: "d-block" },
              [
                _c("v-skeleton-loader", {
                  staticClass: "mt-2 px-1 rounded-md",
                  attrs: {
                    transition: "fade-transition",
                    type: "image",
                    height: "100",
                  },
                }),
                _c("v-skeleton-loader", {
                  staticClass: "mt-2 px-1 rounded-md",
                  attrs: {
                    transition: "fade-transition",
                    type: "image",
                    height: "100",
                  },
                }),
              ],
              1
            ),
          ]),
        ]),
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }